let environment = 'UAT';
let mappingId = '1f8VoU4c6Z8GqzzD9ugnGW';

if (typeof window !== 'undefined' && (
	window.location.hostname.indexOf('webdev') === -1 &&
	window.location.hostname.indexOf('localhost') === -1
)) {
	// if window is defined and we don't have webdev in the URL we are going to
	// show the live version
	environment = 'master';
	mappingId = '7ByHTOQV8yVViEu5QoZ7nB';
}

export const API_SPACE_ID = 'mmwmqax9wgw8';
export const API_TOKEN = '7AmMWulxLwzMp4Q0gynb5FDcMj3ZUoZukpStnmWHGe8';
export const API_HOST = 'cdn.contentful.com';
export const API_ENV = environment;
export const MAPPING_ID = mappingId;